import { Icon } from '@livable/saas-react-components';
import { Stepper, Step, StepLabel } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './styles';
export default function AddNewPropertyStepper(props) {
  const classes = useStyles();
  const _props$activeStep = props.activeStep,
    activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
    _props$steps = props.steps,
    steps = _props$steps === void 0 ? [] : _props$steps,
    _props$handleStep = props.handleStep,
    handleStep = _props$handleStep === void 0 ? () => {} : _props$handleStep,
    completedSteps = props.completedSteps,
    hideBreadcrumbs = props.hideBreadcrumbs;
  const isActive = index => index <= completedSteps || index === activeStep;
  const EditIcon = () => /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  });
  const SuccessIcon = () => /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  });
  const getStepIcon = index => {
    return index === activeStep || index >= completedSteps ? EditIcon : SuccessIcon;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.stepperWrapper, " ").concat(hideBreadcrumbs && classes.hideBreadcrumbs)
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true
  }, steps.map((step, index) => /*#__PURE__*/React.createElement(Step, {
    key: step.label,
    className: isActive(index) ? classes.activeStep : classes.disabledStep
  }, /*#__PURE__*/React.createElement(StepLabel, {
    onClick: handleStep(index),
    StepIconComponent: getStepIcon(index),
    'custom-attribute': '91-add-property-stepper'
  }, step.label)))));
}
AddNewPropertyStepper.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string,
    component: PropTypes.node
  })),
  handleStep: PropTypes.func
};